import { ICompletedItemFilter } from "../../../../state";

export const numericFilter = (filter: ICompletedItemFilter, name: string, value: number): boolean => {
    if (filter[name] && filter[name].use) {
        if (filter[name].type === 'limits') {
            return value >= Number(filter[name].value) && value <= Number(filter[name].max)
        } else {
            return value === Number(filter[name].value)
        }
    } else {
        return true;
    }
}

export const stringFilter = (filter: ICompletedItemFilter, name: string, value: string): boolean => {
    if (filter[name] && filter[name].use) {
        if (filter[name].type === 'limits') {
            return value >= filter[name].value && value <= filter[name].max
        } else {
            return value.includes(filter[name].value)
        }
    } else {
        return true;
    }
}

export const selectFilter = (filter: ICompletedItemFilter, name: string, value: string): boolean =>
    filter[name] && filter[name].use
        ? filter[name].value === value
        : true